import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import OptionsOIChangeSinceLastExpiryFull from './options-oi-change-since-last-expiry-full';

export const OptionsOIChangeSinceLastExpiryFullWidget = (props) => {
  const queryClient = new QueryClient();
  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.style.overscrollBehaviorY = 'auto';

    const style = document.createElement('style');
    style.innerHTML = `
      body::-webkit-scrollbar {
        background-color: transparent;
      }
    `;
    document.head.appendChild(style);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <OptionsOIChangeSinceLastExpiryFull {...props} />
    </QueryClientProvider>
  );
};
